import { createContainer, createHook, createStore, defaults } from 'react-sweet-state';

import DashboardMenuServiceFactory from '../services/DashboardMenuService';
import DashboardServiceFactory from '../services/DashboardService';

// Integrate react-sweet-state with the redux dev tools.
defaults.devtools = true;

function load() {
    return ({ setState }, { dashboardMenuService = DashboardMenuServiceFactory() }) => {
        // Set loading to true.
        setState({
            loading: true,
            error: null,
        });

        return dashboardMenuService
            .get()
            .then((menu) => {
                setState({
                    loading: false,
                    initialized: true,
                    error: null,
                    menu,
                });
            })
            .catch((error) => {
                setState({
                    loading: false,
                    initialized: false,
                    error,
                    menu: undefined,
                });
            });
    };
}

function update(newDashboardMenu) {
    return ({ setState }, { dashboardMenuService = DashboardMenuServiceFactory() }) => {
        return dashboardMenuService.update(newDashboardMenu).then((menu) => {
            setState({
                menu,
            });
        });
    };
}

function deleteDashboard(dashboard) {
    return ({ dispatch }, { dashboardService = DashboardServiceFactory() }) => {
        return dashboardService.remove(dashboard.id).then(() => {
            dispatch(load());
        });
    };
}

const DashboardMenuStore = createStore({
    name: 'DashboardMenu',

    initialState: {
        initialized: false,
        loading: true,
        error: undefined,
        menu: undefined,
    },

    actions: {
        load,
        update,
        deleteDashboard,
    },
});

export const DashboardMenuStoreContainer = createContainer(DashboardMenuStore);

export const useDashboardMenu = createHook(DashboardMenuStore);

export const useMenu = createHook(DashboardMenuStore, {
    selector: (state) => state?.menu,
});
